import RecordView from "./RecordView"
export default RecordView
